export interface AccountProfile {
  id: number;
  firstName: string;
  email: string;
  phoneNumber: string;
}

export const isSuccess = (
  output: any
) => {
  const payload = output ? JSON.parse(output) : null;
  return payload && payload['body'] && payload['body']['statusOfRequest'] && payload['body']['statusOfRequest']['statusCode'] === "0";
};
export const successData = (
  output: any
) => {
  const payload = output ? JSON.parse(output) : null;
  return payload && payload['body'] && payload['body']['data'] && payload['body']['data'];
};
export const errorMessage = (
  output: any
) => {
  const payload = output ? JSON.parse(output) : null;
  return payload && payload['body'] && payload['body']['statusOfRequest'] && payload['body']['statusOfRequest']['message'] ? payload['body']['statusOfRequest']['message'] : "";
};
